import { data } from "jquery"

export class Cart {
	constructor() {
		//this.yaCounter = yaCounter52696993;
		//sbjs.init();
	}

	add2cart(id, count) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			data: "action=add&id=" + id + "&count=" + count,
			dataType: "json",
			success: function(res) {
				//console.log(res.new_count);
				_this.updateHeader(res.new_count)
				//yaCounter8888326.reachGoal('add_to_cart');
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	remove(id) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			data: "action=deleteRestoreCart&id=" + id + "&op=delete",
			dataType: "json",
			success: function(res) {
				//console.log(res.new_count);
				_this.updateHeader(res.new_count)
				_this.parseCartInfo(res)
				//yaCounter8888326.reachGoal('add_to_cart');
				if (!res.new_count) {
					$(".inner-page__title.inner-page__title--big").replaceWith(
						"<h1 class='inner-page__title'>В корзине нет товаров. <a href='/catalog/'>Добавить?</a></h1>"
					)
					$(".split").remove()
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	updateCount(parent) {
		let el = $(parent)
		let count = el.val()
		let id
		if (el.closest(".popup-cart").length) {
			id = el
				.closest(".cart-item")
				.find("input.cart-item-id")
				.val()
			this.updateItemCount(id, count)
		} else if (el.closest(".cart-item").length) {
			id = el.closest(".cart-item").attr("data-id")
			this.updateCartCount(id, count)
		}
	}

	updateItemCount(id, count) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			data: "action=update_item_count&id=" + id + "&count=" + count,
			dataType: "json",
			success: function(res) {
				//console.log(res.new_count);
				_this.updateHeader(res.new_count)
				//yaCounter8888326.reachGoal('add_to_cart');
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	updateCartCount(id, count) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			data: "action=update_cart_count&id=" + id + "&count=" + count,
			dataType: "json",
			success: function(res) {
				//console.log(res.new_count);
				_this.updateHeader(res.new_count)
				_this.parseCartInfo(res)
				//yaCounter8888326.reachGoal('add_to_cart');
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	updateHeader(count) {
		console.log(count)
		if (count == null) {
			count = 0
		}
		$(".header-panel__basket-quantity").text(count)
		if (count > 0) {
			$(".header-panel__basket span").text("Корзина")
			$(".header-panel__basket-quantity").addClass("full")
		} else {
			$(".header-panel__basket span").text("Корзина пуста")
			$(".header-panel__basket-quantity").removeClass("full")
		}
	}

	getDiscount() {
		let _this = this
		let card = $("#mod_cart_1_discount_card_number").val()
		if (!card) return

		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			data: "action=getDiscount&card=" + card,
			dataType: "json",
			success: function(res) {
				console.log(res)
				if (res.status == "success") {
					$(".cart-form__discount-text")
						.text(
							"Ваша скидка по карте составила: " +
								(parseInt(res.sum_no_discount) - parseInt(res.sum)) +
								" ₽"
						)
						.attr("data-discount", res.discount)
					$("#cart_sum").text(res.sum)
				} else {
					$(".cart-form__discount-text")
						.text("Карта не найдена")
						.attr("data-discount", 0)
					$("#cart_sum").text(res.sum)
				}
				_this.calcTotalSum()
				$(".cart-form__discount-text").slideDown()
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	getPromocode() {
		let _this = this
		let promocode = $("#mod_cart_promocode").val()
		if (!promocode) return

		console.log(promocode)

		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			data: "action=getPromocode&promocode=" + promocode,
			dataType: "json",
			success: function(res) {
				if (res.status == "success") {
					$(".cart-form__promocode-text span").text(
						"Ваша скидка по промокоду " +
							res.message +
							": " +
							(parseInt(res.sum_no_discount) - parseInt(res.sum)) +
							" ₽"
					)
					$(".cart-form__promocode-text").attr(
						"data-promocode",
						parseInt(res.sum_no_discount) - parseInt(res.sum)
					)
					$("#cart_sum").text(res.sum)
				} else {
					$(".cart-form__promocode-text span").text(res.message)
					$(".cart-form__promocode-text").attr("data-promocode", 0)
					$("#cart_sum").text(res.sum)
				}
				_this.calcTotalSum()
				$(".cart-form__promocode-text").slideDown()
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	cancelPromocode() {
		let _this = this
		$("#mod_cart_promocode").val("")
		$(".cart-form__promocode-text").attr("data-promocode", 0)
		$(".cart-form__promocode-text").slideUp()
	}

	getCartCount() {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			data: "action=getCartCount",
			dataType: "json",
			success: function(res) {
				console.log(res.new_count)
				_this.updateHeader(res.new_count)
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	validAdress(adress) {
		$(".cart-form__submit").prop("disabled", true)
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=4&action=validAdress",
			type: "POST",
			data: { adress: adress },
			dataType: "json",
			success: function(res) {
				$(".cart-form__submit").prop("disabled", false)
				let field = $("#str_adress")
				let qc_text = {
					10: "неизвестный дом",
					9: "неизвестный адрес",
					7: "похоже на иностранный адрес",
					6: "неизвестный нам адрес :-(",
					5: "еще можно указать квартиру",
					4: "укажите дом",
					3: "укажите улицу",
					2: "укажите город",
					1: "укажите регион",
					0: "адрес корректный!",
				}
				console.log(res)
				if (res.qc_complete === 0) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".cart-form__data-comment")
						.text(qc_text[res.qc_complete])
				} else if (res.qc_complete == 5) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".cart-form__data-comment")
						.text(qc_text[res.qc_complete])
				} else if (res.qc_complete == 10) {
					field[0].setCustomValidity("")
					field.val(res.result)
					field
						.parent()
						.find(".cart-form__data-comment")
						.text("")
				} else {
					field[0].setCustomValidity(qc_text[res.qc_complete])
					field
						.parent()
						.find(".cart-form__data-comment")
						.text(qc_text[res.qc_complete])
				}
			},
			fail: function(e) {
				$(".cart-form__submit").prop("disabled", false)
				console.log(e)
			},
		})
	}

	findOrg(inn, findOrg) {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=4&action=findOrg",
			type: "POST",
			data: { inn: inn, type_org: findOrg },
			dataType: "json",
			success: function(res) {
				console.log(res)

				if (res.suggestions != undefined) {
					if (res.suggestions.length > 0) {
						let org = res.suggestions[0].data

						if (org.name != undefined) {
							if ($("input[name='str_org']").val() == "") {
								if (
									org.name.short_with_opf != undefined &&
									org.name.short_with_opf.length > 0
								) {
									$("input[name='str_org']").val(org.name.short_with_opf)
								} else if (
									org.name.full_with_opf != undefined &&
									org.name.full_with_opf.length > 0
								) {
									$("input[name='str_org']").val(org.name.full_with_opf)
								}
							}
						}

						if (org.kpp != undefined) {
							if ($("input[name='str_kpp']").val() == "")
								$("input[name='str_kpp']").val(org.kpp)
						}

						if (org.address != undefined) {
							if ($("input[name='str_adress_j']").val() == "") {
								if (
									org.address.unrestricted_value != undefined &&
									org.address.unrestricted_value.length > 0
								) {
									$("input[name='str_adress_j']").val(
										org.address.unrestricted_value
									)
								} else if (
									org.address.value != undefined &&
									org.address.value.length > 0
								) {
									$("input[address='str_adress_j']").val(org.address.value)
								}
							}
						}
					}
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	getCartInfo() {
		let _this = this
		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			data: "action=getCartInfo",
			dataType: "json",
			success: function(res) {
				console.log(res)
				_this.updateHeader(res.count)
				_this.parseCartInfo(res)
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	checkBeforeSubmit() {
		let _this = this
		let noPay = false
		$.ajax({
			url: "/ajax.php?mid=4",
			type: "POST",
			async: false,
			data: "action=getCartInfo",
			dataType: "json",
			success: function(res) {
				console.log(res)
				_this.parseCartInfo(res)
				let noOrder = res.no_order
				if (noOrder) {
					$([document.documentElement, document.body]).animate(
						{
							scrollTop: $("h1").offset().top,
						},
						200
					)
					swal(
						"Внимание!",
						"Один или несколько товаров закончились, пожалуйста, удалите их из корзины, чтобы оформить заказ."
					)
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})

		return !noPay
	}

	parseCartInfo(res) {
		let end
		if (res.count % 10 == 1 && res.count % 100 != 11) end = ""
		else if (
			res.count % 10 > 1 &&
			res.count % 10 < 5 &&
			(res.count % 100 < 11 || res.count % 100 > 15)
		)
			end = "а"
		else end = "ов"

		$(".inner-page__title.inner-page__title--big").text(
			"В корзине " + res.count + " товар" + end + ":"
		)
		$(".cart-main__total").text("Общая сумма заказа: " + res.sum + " ₽ ")
		$("#cart_sum").text(res.sum)

		$(".cart-form__radio-label").each(function() {
			let el = $(this)
			let i = el.attr("for").replace(/delivery-/, "")
			el.find(".delivery-normal .cart-form__radio-title b").text(
				res.delivery[i] + " ₽"
			)
		})

		if (res.no_pay) {
			$(
				".cart-form__radio-label[data-delivery != 0][data-delivery != 7] .delivery-normal"
			).hide()
			$(
				".cart-form__radio-label[data-delivery != 0][data-delivery != 7] .delivery-nopay"
			).show()
			$(".res-delivery-normal").hide()
			$(".cart-form__total").hide()
		} else {
			$(
				".cart-form__radio-label[data-delivery != 0][data-delivery != 7] .delivery-normal"
			).show()
			$(
				".cart-form__radio-label[data-delivery != 0][data-delivery != 7] .delivery-nopay"
			).hide()
			$(".res-delivery-normal").show()
			$(".cart-form__total").show()
		}

		//Для почты НП
		$(".cart-form__radio-label[data-delivery = 7] .delivery-normal").hide()
		$(".cart-form__radio-label[data-delivery = 7] .delivery-nopay").hide()
		$(".cart-form__radio-label[data-delivery = 7] .delivery-nopay-2").show()

		if (res.onlytk) {
			$(".cart-form__radio-item[data-not-tk = 1]").hide()
		} else {
			$(".cart-form__radio-item[data-not-tk = 1][data-postpay = 1]").show()
		}
		$("#delivery-choose").attr("data-onlytk", res.onlytk ? 1 : 0)

		if (res.can_nalp == 0) {
			$("#cart-step-2 .cart-form__tab-nav").hide()
			$("#cart-step-2 .cart-form__tab-nav input[type=radio]#nalp-0")
				.prop("checked", true)
				.trigger("change")
		} else {
			$("#cart-step-2 .cart-form__tab-nav").fadeIn()
		}

		if (res.unavaibleItems.length) {
			for (let i = 0; i < res.unavaibleItems.length; i++) {
				let el = $(".cart-item[data-id = " + res.unavaibleItems[i] + "]")
				el.find(".cart-item__price")
					.addClass("warning")
					.text("Товар закончился")
			}
		}

		if (res.no_order) {
			$(".cart-form__submit").prop("disabled", true)
		} else {
			$(".cart-form__submit").prop("disabled", false)
			$(".cart-form").show()
			$("h3.inner-page__warning").hide()
		}

		this.calcTotalSum(res.sum)
	}

	calcTotalSum() {
		let sum = $("#cart_sum").text()
		let deliveryId = $(".cart-form__radio-item input:checked").val()
		let discount = $(".cart-form__discount-text").attr("data-discount")
		let deliverySum = 0

		if (deliveryId)
			deliverySum = parseInt(
				$(".cart-form__radio-item input:checked")
					.closest(".cart-form__radio-item")
					.find(".cart-form__radio-title b")
					.text()
			)

		$("#cart_delivery_sum").text(deliverySum)
		$("#cart_total_sum").text(parseInt(sum) + parseInt(deliverySum))

		$("#cart_total_sum2").text(
			((parseInt(sum) + parseInt(deliverySum)) * (100 - discount)) / 100
		)
	}
}

//Для почты НП
$(".cart-form__radio-label").click(function(e) {
	var deliveryId = $(this).data("delivery")
	if (deliveryId == 7) $(".res-delivery-normal").hide()
	else $(".res-delivery-normal").show()
})
